import Clipboard from '../../../../../../modules/Gull/Framework/clipboard.js';

const validateView = {

	init() {

		new Clipboard().init();

		// Disabled button if value is empty or not set
		function disableIfEmpty(t, v) {
			t.disabled = true;
			if (v !== null || v !== '') {
				t.disabled = false;
			}
		}

		// Bind opmerkingen select function to select
		document.body.addEventListener('change', function(event) {
			if (event.target.classList.contains('toelichting-keuze')) {
				var modal = event.target.closest('.modal');
				var toelichtingInput = modal.querySelector('.toelichting');
				toelichtingInput.value = event.target.value;
				var submitButton = modal.querySelector('[type=submit]');
				disableIfEmpty(submitButton, event.target.value);
			}
		});

	}

};

export default validateView;
